export default __webpack_public_path__ + "static/media/service2.86cc6403.png";